<template>
  <div class="pcList" id="pcList">
    <van-empty v-if="!meetingList.length" class="custom-image">
      <!-- <van-empty v-if="true" class="custom-image"> -->
      <template #image> <img :src="emptyimg" alt="" /> </template>
      <p class="empty_tip_1">暂无直播</p>
      <p class="empty_tip_2">逛逛其他精彩直播吧</p>
    </van-empty>
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      :finished-text="meetingList.length ? '到底啦 ~' : ''"
    >
      <div class="meetinglist">
        <template v-if="meetingList.length">
          <!-- <div class=""> -->
          <div
            v-for="(item, index) in meetingList"
            :key="index"
            class="meetinglist_item"
            @mouseleave="changeLeave($event)"
          >
            <!-- <a :href="item.liveAddress"> -->
            <div @click="goMeet(item.liveAddress)">
              <div class="item_img">
                <img
                  v-lazyload="
                    item.videoBackgroundImageId
                      ? IMAGE_API + item.videoBackgroundImageId
                      : item.afterMeetingImage
                      ? IMAGE_API + item.afterMeetingImage
                      : defaultImg
                  "
                  :src="defaultImg"
                  alt=""
                />
              </div>
              <div class="item_title">
                <p style="color: #0091ff" class="title_p">
                  {{ moment(item.startTime).format("MM月DD日 HH:mm") }}
                </p>
                <div v-if="item.status == 0" class="livetype livetype_wait">
                  <img :src="wait" alt="" />
                  <countdown-pc :startTime="item.startTime"></countdown-pc>
                </div>
                <div
                  v-if="item.status == 1 || item.status == 2"
                  class="livetype livetype_live"
                >
                  <img :src="live" alt="" /> <span>直播中</span>
                </div>
                <div v-if="item.status == 3" class="livetype livetype_back">
                  <img :src="back" alt="" /> <span>直播回顾</span>
                </div>
                <div
                  v-if="item.status == 4 || item.status == 5"
                  class="livetype livetype_end"
                >
                  <img :src="end" alt="" /> <span>已结束</span>
                </div>
                <!-- <p :class="isTopPc ? 'hot_P' : 'title_p'"> -->
                <p class="title_text" style="padding-left: 2px">
                  <!-- <div style="width:45px;height: 23px;background-image: url('../assets/newIcon/hot.gif');background-size: cover;"> -->
                  <!-- <img :src="fire" alt="" v-if="isTopPc" class="hot_img" /> -->
                  <!-- </div> -->
                  {{ item.name }}
                </p>
              </div>
            </div>
            <!-- </a> -->
            <!-- </div> -->
          </div>
        </template>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getMeetingList } from "../request/request";
import { IMAGE_API } from "../request/api";
// import Countdown from "./countdown.vue";
import moment from "moment";
import CountdownPc from "./countdownPc.vue";
export default {
  props: {
    livetype: String,
    isTop: {
      type: Boolean,
      required: false,
    }, //是否顶置
    isShowFire: Boolean,
    time: {
      Type: String,
      required: false,
      default: "",
    },
    transAll: Number,
    type: String,
    // 切换点击
    tabIndex: Number,
    // pc切换
    selcetDate: String,
  },
  components: {
    // Countdown,
    CountdownPc,
  },
  mounted() {
    this.getMeetingLists();
  },
  watch: {
    isTop() {
      this.clearData();
      this.getMeetingLists();
    },
    tabIndex(newValue) {
      if (newValue == 4) {
        //推荐
        this.isTopPc = true;
      } else {
        this.isTopPc = false;
      }
      this.clearData();
      this.getMeetingLists();
      // console.log(newValue,  "侧边栏切换");
    },
  },
  data() {
    const defaultImg = require("../assets/images/home/defaultImage.png");
    const fire = require("../assets/newIcon/hot.gif");
    const emptyimg = require("../assets/images/home/empty.png");
    const live = require("../assets/newIcon/newIcon1/live.png");
    const back = require("../assets/newIcon/newIcon1/back.png");
    const end = require("../assets/newIcon/newIcon1/end.png");
    const wait = require("../assets/newIcon/newIcon1/wait.png");

    return {
      moment,
      IMAGE_API,
      defaultImg,
      fire,
      emptyimg,
      live,
      back,
      end,
      wait,
      meetingList: [],
      originMeetingList: [],
      refreshing: false,
      loading: false,
      finished: false,
      hasNoData: false,
      page: 1,
      timer: null,
      leftList: [],
      rightList: [],
      pageWaite: 1,
      pageMeeting: 1,
      pageBack: 1,
      // 直播中 待开播 回放数据
      waiteData: [],
      meetingData: [],
      backData: [],
      // 是否有下页数据
      isMoreWaiteData: true,
      isMoreMeetingData: true,
      isMoreBackData: true,
      // 是否往下请求数据
      isGoMeetingData: true,
      isGobackData: true,
      isTopPc: false,
    };
  },
  methods: {
    // 直播回顾
    async getOnlyBackList() {
      let { data: backData } = await getMeetingList({
        page: this.pageBack,
        pageSize: 10,
        // filterDate: this.time, //日期
        Status: [3, 4], //状态
      });
      let arr = backData.data.filter((item) => {
        return item.status !== 3;
      });
      this.meetingList.push(...arr);
      if (backData.totalElements > 10 * this.pageBack) {
        this.pageBack++;
        this.isMoreBackData = true;
      } else {
        this.isMoreBackData = false;
      }
    },
    //直播中 1 2
    async getMeetingList() {
      let { data: meetingData } = await getMeetingList({
        page: this.pageMeeting,
        pageSize: 20,
        filterDate: this.selcetDate, //日期
        Status: [1, 2], //状态
        isTop: this.isTopPc,
      });
      this.meetingData.push(...meetingData.data);
      if (meetingData.totalElements > 10 * this.pageMeeting) {
        this.pageMeeting++;
        this.isMoreMeetingData = true;
      } else {
        this.isMoreMeetingData = false;
      }
      // 如果请求条数小于十  就继续请求下一个
      if (meetingData.data.length < 10) {
        this.isGoMeetingData = true;
      } else {
        this.isGoMeetingData = false;
      }
    },

    async getWaiteList() {
      //待开播 0
      let { data: waiteData } = await getMeetingList({
        page: this.pageWaite,
        pageSize: 20,
        filterDate: this.selcetDate, //日期
        Status: [0], //状态
        isTop: this.isTopPc,
      });
      this.waiteData.push(...waiteData.data);

      if (waiteData.totalElements > 10 * this.pageWaite) {
        // 如果待直播条数大于 页书*10
        this.pageWaite++;
        // 还有更多
        this.isMoreWaiteData = true;
      } else {
        this.isMoreWaiteData = false;
      }
      if (waiteData.data.length < 10) {
        this.isGobackData = true;
      } else {
        this.isGobackData = false;
      }
    },

    //回放 3  结束 4
    async getBackList() {
      let { data: backData } = await getMeetingList({
        page: this.pageBack,
        pageSize: 20,
        filterDate: this.selcetDate, //日期
        Status: [3, 4], //状态
        isTop: this.isTopPc,
      });
      this.backData.push(...backData.data);
      if (backData.totalElements > 10 * this.pageBack) {
        this.pageBack++;
        this.isMoreBackData = true;
      } else {
        this.isMoreBackData = false;
      }
    },
    async getMeetingLists() {
      // 每次刷新默认 要往下请求
      this.isGoMeetingData = true;
      this.isGobackData = true;
      this.loading = true;

      // 如果直播中有更多 就继续请求直播中数据
      if (this.isMoreMeetingData) {
        await this.getMeetingList();
      }
      // 带直播有更多|&& 直播中请求条数小于10的时候才继续请求待直播
      if (this.isMoreWaiteData && this.isGoMeetingData) {
        await this.getWaiteList();
      }

      if (this.isMoreBackData && this.isGoMeetingData && this.isGobackData) {
        await this.getBackList();
      }
      // 全部数据
      let arr = [];
      arr.push(...this.meetingData, ...this.waiteData, ...this.backData);
      // this.meetingList.
      let map = new Map();
      arr.forEach((item) => {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      this.meetingList = [...map.values()];
      // this.meetingList = [...this.meetingData,
      //   ...this.waiteData,
      //   ...this.backData,]
      // this.meetingList.push(
      //   ...this.meetingData,
      //   ...this.waiteData,
      //   ...this.backData,
      // );
      // console.log(
      //   [...this.meetingData, ...this.waiteData, ...this.backData],
      //   "leibiao"
      // );

      this.loading = false;
    },
    clearData() {
      this.pageWaite = 1;
      this.pageMeeting = 1;
      this.pageBack = 1;
      (this.isMoreWaiteData = true),
        (this.isMoreMeetingData = true),
        (this.isMoreBackData = true);
      this.finished = false;
      this.waiteData = [];
      this.meetingData = [];
      this.backData = [];
      this.meetingList = [];
    },
    goMeet(address) {
      if (address) {
        location.href = address;
      }
    },
    // 鼠标移出
    changeLeave(e) {
      e.target.className = "meetinglist_item leave ";
      // console.log(e, 22);
    },
    onLoad() {
      // console.log("到底了 执行onLoad");
      this.timer = setTimeout(() => {
        this.loading = true;
        if (this.threeOptionsIndex == 3) {
          if (this.isMoreBackData) {
            this.getOnlyBackList();
          } else {
            this.loading = false;
            this.finished = true;
          }
        } else {
          if (
            this.isMoreWaiteData ||
            this.isMoreMeetingData ||
            this.isMoreBackData
          ) {
            this.getMeetingLists();

            // this.loading = false;
            // this.finished = true;
          } else {
            this.loading = false;
            this.finished = true;
          }
        }
      }, 1000);
    },

    formatList(data) {
      let evenList = data.filter((x, index) => {
        return index % 2 == 0;
      });
      let oddList = data.filter((x, index) => {
        return index % 2 != 0;
      });
      this.leftList = evenList;
      this.rightList = oddList;
      return evenList.concat(oddList);
    },
    formatItem(item) {
      const now = moment();
      if (now.isBefore(item.startTime)) {
        let days = moment.duration(now.diff(moment(item.startTime))).days();

        if (days < 0) {
          item.days = Math.abs(days);
        }
      } else if (now.isAfter(item.startTime)) {
        item.isAfter = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pcList {
  width: 100%;
}

.meetinglist {
  width: 100%;
  padding-top: 5px;
  height: calc(100% - 10px);
  display: flex;
  justify-content: space-between;

  // display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  .meetinglist-left,
  .meetinglist-right {
    width: 520px;
    display: flex;
    flex-direction: column;
  }

  .meetinglist_item:hover {
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.2);
    transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
  }
  .leave {
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.2);
    transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
  }
  .meetinglist_item {
    width: 520px;
    border-radius: 6px;
    height: 142px;
    display: block;
    padding: 0px;
    box-sizing: border-box;
    margin-top: 0px;
    margin-bottom: 14px;
    position: relative;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
    cursor: pointer;

    > div {
      height: 100%;
      display: flex;

      .item_img {
        width: 228px;
        height: 143px;
        border-radius: 8px 0 0 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .item_title {
        width: 290px;
        box-sizing: border-box;
        color: #333333;
        padding: 10px;
        position: relative;
        font-family: OPPOSans-B;
        .title_text {
          font-family: OPPOSans-M;
        }
        img {
          width: 34px;
          height: 36px;
        }
        .hot_P {
          position: relative;
          height: 55px;
          .hot_img {
            // position: absolute;
            // top: 0;
            margin-left: -5px;
            width: 32px;
            height: 30px;
            vertical-align: bottom;
            margin-right: -6px;
          }
          .hot_span {
            position: absolute;
            top: 5px;
            left: 30px;
          }
        }
        p {
          width: 100%;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          //   font-size: 28px;
          margin: 0;
          padding-top: 5px;
        }

        .livetype {
          box-sizing: border-box;
          height: 30px;
          // padding-left: 7px;
          // margin: 0 10px;
          display: flex;
          align-items: center;
          color: black;
          border-bottom: 1px solid #f2f2f2;
          span {
            margin-left: 2px;
          }
          img {
            vertical-align: bottom;
          }
        }

        .livetype_live {
          //   background-color: RGBA(55, 175, 0, 0.8);
          color: #27ae60;

          img {
            width: 21px;
            height: 20px;
          }
        }

        .livetype_end {
          //   background-color: RGBA(0, 0, 0, 0.38);
          color: #999999;

          img {
            width: 15px;
            height: 16px;
          }
        }

        .livetype_wait {
          //   background-color: RGBA(255, 175, 0, 0.8);
          color: #ffaf00;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .livetype_back {
          //   background-color: RGBA(0, 0, 0, 0.38);
          color: #a055bf;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}

.finish_text {
  font-size: 24px;
  text-align: center;
  color: #999999;
}

/deep/ .van-cell {
  padding: unset;
}

/deep/ .van-cell::after {
  content: none;
}

/deep/ .van-empty__image {
  margin-top: 100px;
  width: 280px;
  height: 206px;
}

/deep/ .van-empty {
  margin: 0 auto;
}

/deep/ .van-empty__bottom {
  p {
    width: 100vw;
    text-align: center;
  }

  .empty_tip_1 {
    width: 100%;
    font-weight: 500;
    font-size: 35px;
    color: #999999;
    margin-bottom: 0;
  }

  .empty_tip_2 {
    width: 100%;
    font-weight: 400;
    font-size: 30px;
    color: #cccccc;
  }
}

/deep/ .van-list {
  .van-list__finished-text {
    font-size: 24px !important;
  }

  .van-loading__text {
    font-size: 24px !important;
  }
}
</style>
